import { MarketExprtChargeCodesPanel } from "../MarketExprtChargeCodesPanel";
import { MarketExprtOutputFiltersPanel } from "../MarketExprtOutputFiltersPanel";
import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDatControl extends Layout {
    buttonOrganizationAuth: Button;
    checkboxActualDelivery: Checkbox;
    checkboxActualPickup: Checkbox;
    checkboxBrkTotalPaid: Checkbox;
    checkboxCargoIns: Checkbox;
    checkboxCarrierLinehaul: Checkbox;
    checkboxCarrierLoading: Checkbox;
    checkboxCarrierPayAdjustment: Checkbox;
    checkboxCarrierStopPay: Checkbox;
    checkboxCarrierType: Checkbox;
    checkboxCommodity: Checkbox;
    checkboxConsigneeAddress: Checkbox;
    checkboxCubicFeet: Checkbox;
    checkboxCustAccessorials: Checkbox;
    checkboxCustFuelSurcharge: Checkbox;
    checkboxCustStopCharges: Checkbox;
    checkboxCustomerLineHaul: Checkbox;
    checkboxCustomerLoading: Checkbox;
    checkboxDeliveryAppt: Checkbox;
    checkboxDeliveryApptTime: Checkbox;
    checkboxDestAppEnd: Checkbox;
    checkboxDestCity: Checkbox;
    checkboxDestState: Checkbox;
    checkboxDestZip: Checkbox;
    checkboxDispatcher: Checkbox;
    checkboxFreightClass: Checkbox;
    checkboxFreightValue: Checkbox;
    checkboxFuelSurchg: Checkbox;
    checkboxHazmat: Checkbox;
    checkboxIncludeDotMcNumber: Checkbox;
    checkboxLinearFeet: Checkbox;
    checkboxLoadNumber: Checkbox;
    checkboxLocationName: Checkbox;
    checkboxMiscNames: Checkbox;
    checkboxMode: Checkbox;
    checkboxMoveDistance: Checkbox;
    checkboxOperationsUser: Checkbox;
    checkboxOrderBookTm: Checkbox;
    checkboxOriginCity: Checkbox;
    checkboxOriginState: Checkbox;
    checkboxOriginZip: Checkbox;
    checkboxPayDate: Checkbox;
    checkboxPaymentTerms: Checkbox;
    checkboxPickupAppt: Checkbox;
    checkboxPickupApptEnd: Checkbox;
    checkboxPickupApptTime: Checkbox;
    checkboxScacCode: Checkbox;
    checkboxServiceLevel: Checkbox;
    checkboxShipmentExcpt: Checkbox;
    checkboxShipperAddress: Checkbox;
    checkboxSpotOrContract: Checkbox;
    checkboxTotalPaid: Checkbox;
    checkboxTotalPickups: Checkbox;
    checkboxTotalStopOffs: Checkbox;
    checkboxTrailerDetail: Checkbox;
    checkboxTrailerType: Checkbox;
    checkboxUnitsType: Checkbox;
    checkboxWeight: Checkbox;
    checkboxmPactUnitCount: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    labelAssociatedUsers: Label;
    labelAuthStatus: Label;
    labelMarketExport: Label;
    labelOptions: Label;
    labelOutputSettings: Label;
    labelPricingAndBid: Label;
    labelRateOptions: Label;
    labelRateTypes: Label;
    layoutChargeCodes: MarketExprtChargeCodesPanel;
    layoutOutputFilters: MarketExprtOutputFiltersPanel;
    marketRateExportSection: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel7: Panel;
    panel8: Panel;
    panelDatDefault: Panel;
    panelDatSettings: Panel;
    panelMarketRateGeneral: Panel;
    panelRateView: Panel;
    rateIndexSection: Panel;
    sourceLmeUserToken: DataSource;
    sourceMarketrateExprt: DataSource;
    sourceOrganizationToken: DataSource;
    sourcePbwLoadboardServices: DataSource;
    sourceRateIndexControl: DataSource;
    switchAutoRateRetrieval: Switch;
    switchContractRates: Switch;
    switchEnableMarketRate: Switch;
    switchEnabledTypeSelection: Switch;
    switchGenerateMissingRates: Switch;
    switchInternalRates: Switch;
    switchRequestWithBatch: Switch;
    switchSpotRates: Switch;
    switchUseFuelSurcharge: Switch;
    tableRateViewUsers: Table;
    textboxAccountNum: Textbox;
    textboxCarrierName: Textbox;
    textboxCompanyType: Textbox;
    textboxConsigneeName: Textbox;
    textboxCustomerId: Textbox;
    textboxCustomerName: Textbox;
    textboxDatAccountId: Textbox;
    textboxDatPassword: Textbox;
    textboxDatRateviewServiceUrl: Textbox;
    textboxEmail: Textbox;
    textboxEscalationType: Textbox;
    textboxGenerationPreference: Textbox;
    textboxLagDays: Textbox;
    textboxMarketRatePassword: Textbox;
    textboxPassword: Textbox;
    textboxPort: Textbox;
    textboxProcessDays: Textbox;
    textboxRateRequestPreference: Textbox;
    textboxRemoteDirectory: Textbox;
    textboxSftpUrl: Textbox;
    textboxShipperName: Textbox;
    textboxSpecificAreaType: Textbox;
    textboxSpecificTimeFrame: Textbox;
    textboxSpecificTimeframeContract: Textbox;
    textboxTimeoutSeconds: Textbox;
    textboxTrailerType: Textbox;
    textboxUrl: Textbox;
    textboxUserId: Textbox;
    textboxUserName: Textbox;
}
